import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import type { CellProps } from 'react-table';

import type { Tournament } from '@swf/poker';

import TableCellBase from './TableCellBase';

const TableCellPlayers: React.FC<CellProps<Tournament>> = memo((props) => {
  const { row } = props;
  const { formatNumber } = useIntl();

  const displayValue = formatNumber(row.original.entrants);

  return <TableCellBase {...props} displayValue={displayValue} />;
});

export default TableCellPlayers;
